div.filterPopoverContent {
	display: flex;
	align-items: stretch;
	flex-direction: column;
	gap: 15px;
	max-width: 100%;
	max-height: min(650px, 100%);
	padding: 0;
}

.filterHeader {
	display: flex;
	align-items: center;
	justify-content: space-between;
	font-size: 15px;
	padding: 15px 20px 0;
}

h2.filterTitle {
	font-size: 15px;
	font-weight: 600;
	color: black;
}

.filterBody {
	flex: 1;
	min-height: 0;
	padding: 0 20px;
	overflow-y: auto;
}

.filterList {
	width: 100%;
	border-collapse: collapse;
}

.filterSection th {
	text-align: start;
	padding-right: 8px;
}

.filterSection td,
.filterSection th {
	padding-bottom: 20px;
	padding-top: 20px;
}

.filterSection:first-child td,
.filterSection:first-child th {
	padding-top: 0;
}

.filterSection:last-child td,
.filterSection:last-child th {
	padding-bottom: 0;
}

.filterSection + .filterSection td,
.filterSection + .filterSection th {
	border-top: 1px solid #e0e0e0;
}

.filterSectionHeader:global(.MuiTypography-root) {
	font-size: 14px;
	font-weight: 500;
	color: #42296e;
}

.topFilterSectionCell {
	vertical-align: top;
	padding-top: 25px;
}

.filterButtons {
	display: flex;
	align-items: center;
	justify-content: end;
	gap: 10px;
	padding: 0 20px 24px;
}

label.checkboxEntry {
	gap: 7px;
	margin: 0;
}

.checkboxEntry span:global(.MuiTypography-root) {
	font-size: 14px;
	font-weight: 400;
	color: #4d4d4d;
	line-height: 1.6;
}

ul.verticalCheckboxList {
	width: 100%;
	display: flex;
	flex-direction: column;
	padding: 0;
}

button.link {
	color: #0b6f85;
	text-decoration: none;
	border-radius: 2px;
}

button.link:focus-visible {
	outline: 2px solid var(--focus-outline-color-dark);
	outline-offset: 4px;
}

.dateFilterColumn {
	display: flex;
	flex-direction: column;
	gap: 0.625rem;
	width: 100%;

	& .startDateRow {
		display: flex;
		align-items: center;
		gap: 0.5rem;

		& .arrow {
			flex-shrink: 0;
			color: #000;
		}
	}

	& .filterDatePicker {
		height: 35px;
	}
}
